import React from "react";
import cn from "classnames";
import styles from "./styles.module.scss";
import {
  DirectIcon,
  KeywordsIcon,
  RatingsIcon,
  ReviewsIcon,
  RadioIcon,
  RadioCheckedIcon,
} from "./icons";
import type { OrderType, OrderTypeSelectorProps } from "./types";

const OPTIONS: {
  type: OrderType;
  label: string;
  Icon: React.FC<React.SVGProps<SVGSVGElement>>;
}[] = [
  { type: "direct", label: "Direct", Icon: DirectIcon },
  { type: "keywords", label: "Keywords", Icon: KeywordsIcon },
  { type: "ratings", label: "Ratings", Icon: RatingsIcon },
  { type: "reviews", label: "Reviews", Icon: ReviewsIcon },
];

/**
 * The order type picked at the top of the new-order page (Figma 4420:31790,
 * cards 4420:30136): four radio cards in a row, two by two on a phone.
 */
export const OrderTypeSelector: React.FC<OrderTypeSelectorProps> = ({
  value,
  onChange,
  className,
  name = "new-order-type",
  ariaLabel = "Order type",
  options,
}) => (
  <div
    className={cn(styles.group, className)}
    role="radiogroup"
    aria-label={ariaLabel}
  >
    {OPTIONS.filter(({ type }) => !options || options.includes(type)).map(
      ({ type, label, Icon }) => {
        const checked = type === value;
        return (
          <label
            key={type}
            className={cn(styles.card, { [styles.checked]: checked })}
          >
            <input
              type="radio"
              name={name}
              className={styles.input}
              checked={checked}
              onChange={() => {
                if (!checked) onChange(type);
              }}
            />
            <span className={styles.main}>
              <Icon className={styles.icon} aria-hidden />
              <span className={styles.label}>{label}</span>
            </span>
            {checked ? (
              <RadioCheckedIcon className={styles.radio} aria-hidden />
            ) : (
              <RadioIcon className={styles.radio} aria-hidden />
            )}
          </label>
        );
      },
    )}
  </div>
);

export type { OrderType, OrderTypeSelectorProps } from "./types";
